import { Popover, ToggleControl ,   __experimentalHStack as HStack,
         __experimentalVStack as VStack,
         __experimentalText as Text,__experimentalToolsPanelItem as ToolsPanelItem ,Button} from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import {VayuBlocksBackground} from  '@vayu-blocks';

const animationoptions = [
    { label: __('3D Animation', 'vayu-blocks'), value: 'none' },
    { label: __('Effect 1 (3D Tilt Left)', 'vayu-blocks'), value: 'vayu_block_styling-left' },
    { label: __('Effect 2 (3D Tilt Right)', 'vayu-blocks'), value: 'vayu_block_styling-right' },
    { label: __('Effect 3 (Depth Shift)', 'vayu-blocks'), value: 'vayu_block_styling-effect3' },
    { label: __('Effect 4 (3D Clip-Path Left)', 'vayu-blocks'), value: 'vayu_block_styling-effect4-left' },
    { label: __('Effect 5 (3D Clip-Path Right)', 'vayu-blocks'), value: 'vayu_block_styling-effect4-right' },
    { label: __('Effect 6 (3D Draft Bit)', 'vayu-blocks'), value: 'vayu_block_styling-effect10' },
    { label: __('Effect 7 (Tilt Effect)', 'vayu-blocks'), value: 'vayu_block_styling-effect7' },
];

export const Effect = ({ popoverAnchor, setIsVisible, animationData, dataKey, onChange}) => {

    const handleAnimationClick = (animation) => {
        const updatedAnimationData = {
            ...animationData,
            effect: {
                ...animationData.effect,
                animationValue: animation,
            },
        };
    
        onChange(dataKey, updatedAnimationData);
    };
    
    const handleEffectColorChange = (value) => {
        const updatedAnimationData = {
            ...animationData,
            effect: {
                ...animationData.effect,
                effectColor: value,
            },
        };
    
        onChange(dataKey, updatedAnimationData);
    };
    

    const handleEffectHoverChange = (value) => {
        const updatedAnimationData = {
            ...animationData,
            effect: {
                ...animationData.effect,
                effectHover: value,
            },
        };
    
        onChange(dataKey, updatedAnimationData);
    };
    

    return (
        <Popover
            placement="left-start"
            className='vayu_blocks_toolspanel_items_popover'
            anchor={popoverAnchor}
            onClose={() => setIsVisible(false)}
            offset={35}
            resize
        >
            <VStack  style={{padding:'10px',
    width: '280px'}}
                >
                    <Text>
                <h4>{__('3D Animation','vayu-blocks')}</h4>
                <p>{__('Select a 3D animation for your element.')}</p>
                </Text>
                <Text>
                <HStack  spacing="2" wrap={true}>
                    {/* Animation Selection Buttons */}
                    {animationoptions.map(({ value, label }) => (
                        <>
                                {(value === 'none' )? (
                                    <Text
                                        key={value}
                                        className={`vayu-blocks-ihover-main-panel  ${!animationData?.effect?.animationValue || animationData?.effect?.animationValue === value ? 'none-selected' : ''}`}
                                        onClick={() => handleAnimationClick(value)}
                                        title={label}
                                    >
                                        <div style={{margin:'3px 8px'}} className={`vayu-blocks-panel-ihover  vayu-blocks-none-button vayu_blocks_${value}`} ></div>

                                    </Text>
                                ) : (
                                <Text
                                    key={value}
                                    className={`vayu-blocks-ihover-main-panel ${animationData?.effect?.animationValue === value ? 'selected' : ''}`}
                                    onClick={() => handleAnimationClick(value)}
                                    title={label}
                                >
                                    <div className={`vayu-blocks-panel-ihover height-upgrade-effect-animation  ${value}-svg`}></div>
                                </Text>
                            )}
                        </>
                    ))}
                </HStack>
                </Text>

                <Text>
                    <br />
                    {(animationData?.effect?.animationValue === 'vayu_block_styling-effect3' || animationData?.effect?.animationValue === 'vayu_block_styling-effect10') && (
                       <VayuBlocksBackground
                            onChange={(key,value)=>handleEffectColorChange(value)}
                            colorPanel = {[
                                {
                                    active: ['color'],
                                    label: 'Wrapper',
                                    key:'animationData',
                                    value: animationData?.effect?.effectColor,
                                },
                            ]}
                        />
                    )}

                    {(animationData?.effect?.animationValue !== 'none' && animationData?.effect?.animationValue !== 'vayu_block_styling-effect7') && (
                        <>
                            <br />
                            <ToggleControl
                                className='vayu_blocks_togglecontrol'
                                label={__('Hover Effect', 'vayu-blocks')}
                                checked={animationData?.effect?.effectHover}
                                onChange={handleEffectHoverChange}
                            />
                        </>
                    )}
                    </Text>

            </VStack>
        </Popover>
    );
};

export const EffectPanel = ({
    animationData,
    toggleVisible,
    isVisible,
    setPopoverAnchor,
    dataKey, 
    onChange
}) => {

    const handleAnimationClick = (animation) => {
        const updatedAnimationData = {
            ...animationData,
            effect: {
                ...animationData.effect,
                animationValue: animation,
            },
        };
    
        onChange(dataKey, updatedAnimationData);
    };

    const selectedOption = animationoptions.find(option => option.value === (animationData?.effect?.animationValue));
    const name = selectedOption ? selectedOption.label : '';

    return (
        <ToolsPanelItem
            className="vayu_blocks_animation_toolspanel_item"
            hasValue={() => !!animationData?.effect?.animationValue}
            label={__('3D Animation', 'vayu-blocks')}
            onDeselect={() => handleAnimationClick('none')}
            isShownByDefault
        >
            <Button
                ref={setPopoverAnchor}
                onClick={toggleVisible}
                className={`block-editor-panel-animation-settings__dropdown ${isVisible ? 'is-open' : ''}`}
            >
                <HStack alignment="left">
                    {!animationData?.effect?.animationValue || animationData?.effect?.animationValue === 'none' ? (
                        <div className={`vayu-blocks-panel-ihover vayu-blocks-none-button toolaspanel-size-none-button vayu_blocks_none`} />
                    ) : (
                        <div
                            className={`vayu_blocks_hstack_animation_panel_image vayu_blocks_hstack_animation_panel_image_color ${
                                animationData?.effect?.animationValue === 'vayu_block_styling-effect3'
                                    ? 'vayu_block_styling-effect3-svg-extra-origin'
                                    : `${animationData?.effect?.animationValue}-svg`
                            }`}
                        />
                    )}

                    <Text>
                        {
                            __(
                                !animationData?.effect?.animationValue || animationData?.effect?.animationValue === 'none'
                                    ? '3D Animation'
                                    : name
                            )
                        }
                    </Text>
                </HStack>
            </Button>
        </ToolsPanelItem>
    );
};

